import script from "./Spiner.vue?vue&type=script&setup=true&lang=js"
export * from "./Spiner.vue?vue&type=script&setup=true&lang=js"

import "./Spiner.vue?vue&type=style&index=0&id=ad666a76&lang=css"

const __exports__ = script;

export default __exports__